export const captacaoMensalOptions = {
	series: [
		{
			name: '1',
			data: [44, 55, 41, 67, 22, 43, 14, 105, 221, 17, 2, 83],
		},
		{
			name: '2',
			data: [13, 23, 20, 8, 13, 27, 67, 22, 43, 14, 105, 221],
		},
		{
			name: '3',
			data: [13, 23, 20, 8, 13, 27, 67, 22, 43, 14, 105, 221],
		},
		{
			name: '4',
			data: [13, 23, 20, 8, 13, 27, 67, 22, 43, 14, 105, 221],
		},
		{
			name: '5',
			data: [13, 23, 20, 8, 13, 27, 67, 22, 43, 14, 105, 221],
		},
		{
			name: '6',
			data: [13, 23, 20, 8, 13, 27, 67, 22, 43, 14, 105, 221],
		},
		{
			name: '7',
			data: [13, 23, 20, 8, 13, 27, 67, 22, 43, 14, 105, 221],
		},
		{
			name: '8',
			data: [13, 23, 20, 8, 13, 27, 67, 22, 43, 14, 105, 221],
		},
	],
	chart: {
		type: 'bar',
		height: 350,
		stacked: true,
		toolbar: {
			show: false,
		},
		zoom: {
			enabled: true,
		},
	},
	noData: {
		text: 'Sem Dados',
		align: 'center',
		verticalAlign: 'middle',
		offsetX: 0,
		offsetY: 0,
		style: {
			color: undefined,
			fontSize: '14px',
			fontFamily: undefined,
		},
	},
	responsive: [
		{
			breakpoint: 480,
			options: {
				legend: {
					position: 'bottom',
					offsetX: -10,
					offsetY: 0,
				},
			},
		},
	],
	plotOptions: {
		bar: {
			horizontal: false,
			borderRadius: 6,
			borderRadiusApplication: 'end',
			borderRadiusWhenStacked: 'last',
			dataLabels: {
				enabled: false,
			},
		},
	},
	dataLabels: {
		enabled: false,
	},
	colors: [
		'#D2E2F3',
		'#93C7FF',
		'#83BFFF',
		'#75B5F0',
		'#74B7FF',
		'#71B5FF',
		'#6BA4D4',
		'#639DD4',
		'#59A9FF',
		'#55A7FF',
		'#52A8FF',
		'#4FA7FF',
		'#46A3FF',
		'#459EF6',
		'#2D90ED',
		'#2A94FF',
		'#2793FF',
		'#0080FF',
		'#448FD6',
		'#3482CC',
		'#3A7DB8',
		'#74B7FF',
		'#437199',
		'#186EBF',
		'#195386',
		'#164A78',
		'#164269',
		'#173C5E',
		'#153654',
		'#153047',
	].reverse(),
	xaxis: {
		type: 'text',
		categories: [],
		labels: {},
	},
	yaxis: {
		forceNiceScale: true,
		labels: {
			formatter: (value, i) => {
				return GLOBAL.FormatREAL(String(value))
			},

			style: {
				fontSize: '10px',
				fontWeight: 500,
			},
		},
	},
	subtitle: {
		text: 'CAPTAÇÃO SEMESTRAL POR FUNDO',
		offsetY: 5,
		style: {
			fontSize: '12px',
			fontWeight: '600',
			fontFamily: undefined,
			color: '#949799',
		},
	},
	legend: {
		position: 'bottom',
		horizontalAlign: 'center',
		offsetY: 7,
	},
	fill: {
		opacity: 1,
	},
	grid: {
		show: true,
		xaxis: {
			lines: {
				show: true,
			},
		},
		yaxis: {
			lines: {
				show: true,
			},
		},
	},
}

export const captacaoSemestralBarraOptions = {
	chart: {
		type: 'bar', // certifica que o gráfico é do tipo “bar”
		stacked: false,
		toolbar: {
			show: false,
		},
	},
	plotOptions: {
		bar: {
			borderRadius: 6,
			dataLabels: {
				position: 'top',
			},
		},
	},
	xaxis: {
		type: 'category',
	},
	dataLabels: {
		enabled: true,
		offsetY: -20,
		style: {
			fontSize: '10px',
			colors: [
				function (params) {
					const barraIndex = params.seriesIndex
					const valor = params.series[barraIndex][0]
					return valor < 0 ? '#C11F39' : '#003769'
				},
			],
		},
		background: {
			enabled: false,
		},
		formatter: function (val) {
			return val != null ? 'R$ ' + GLOBAL.FMoneyK(val) : ''
		},
	},
	tooltip: {
		x: {
			formatter: (value) => {
				return value
			},
		},
		y: {
			formatter: (val) => {
				return 'R$ ' + GLOBAL.FMoneyK(val)
			},
		},
	},
	grid: {
		borderColor: '#E9ECEF',
		strokeDashArray: 0,
		position: 'back',
		xaxis: { lines: { show: true } },
		yaxis: { lines: { show: true } },
	},
}
